<template>
  <VueFinalModal
    v-model="isOpen"
    content-class="vfm-dialog-500 modal-content modal-delete-content"
  >
    <div class="modal-body modal-delete-body">
      Are you sure you want to delete?
    </div>
    <div class="modal-footer justify-content-end">
      <button
        type="button"
        class="btn medium default"
        @click="cancel"
      >
        Cancel
      </button>
      <button
        type="button"
        class="btn medium primary"
        @click="confirm"
      >
        Delete
      </button>
    </div>
  </VueFinalModal>
</template>

<script>
import { getModalState } from '@/plugins/modal-compat';
export default {
  name: 'DeleteMilestoneModal',
  computed: {
    isOpen: {
      get() { return getModalState('deleteMilestoneModal').isOpen.value; },
      set(val) { getModalState('deleteMilestoneModal').isOpen.value = val; }
    },
    modalParams() { return getModalState('deleteMilestoneModal').params.value; }
  },
  methods: {
    cancel() {
      this.$modal.hide('deleteMilestoneModal');
    },
    confirm() {
      if (this.modalParams && this.modalParams.onConfirm) {
        this.modalParams.onConfirm();
      }
      this.$modal.hide('deleteMilestoneModal');
    }
  }
};
</script>
